module.exports = "\r\n<ng-container *ngIf=\"media\">\r\n\t<a href=\"javascript:void(0)\" (click)=\"mediaModal.show(media.name, media.file)\">\r\n\t\t<image-loader img-class=\"img-thumbnail\" img-src=\"{{media.file.url}}/thumbnail\"></image-loader>\r\n\t</a>\r\n</ng-container>\r\n\r\n<media-view-modal #mediaModal></media-view-modal>\r\n";


//////////////////
// WEBPACK FOOTER
// ./TypeScript/shared/file/media-thumbnail.component.html
// module id = 434
// module chunks = 10